/**
 * @file usuariosActions.js
 * @author Allan de Miranda Silva
 * @author Bene Lemuel Dantas Gondim
 * @description Ações relacionadas a manipulação dos usuários do sistema
 * @version 0.0.1
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

import axios from 'utils/axios'
import { logoutTokenExpirado, criarAlerta } from 'actions'

export const USUARIO_SUCESSO = 'USUARIO_SUCESSO'
export const USUARIO_ERROR = 'USUARIO_ERROR'

export const CRIAR_USUARIO_SUCESSO = 'CRIAR_USUARIO_SUCESSO' //! Dispatch para criar um usuário
export const REDEFINIR_SENHA_USUARIO_NAO_ENCONTRADO = 'REDEFINIR_SENHA_USUARIO_NAO_ENCONTRADO'
export const REDEFINIR_SENHA_EMAIL_ERRADO = 'REDEFINIR_SENHA_EMAIL_ERRADO'
export const REDEFINIR_SENHA_EMAIL_ENVIADO = 'REDEFINIR_SENHA_EMAIL_ENVIADO'

export const REDEFINIR_SENHA_ERRO_TOKEN = 'REDEFINIR_SENHA_ERRO_TOKEN'
export const REDEFINIR_SENHA_SUCESSO = 'REDEFINIR_SENHA_SUCESSO'

export const SOLICITAR_REDEFINIR_SENHA_SUCESSO = 'SOLICITAR_REDEFINIR_SENHA_SUCESSO'
export const SOLICITAR_REDEFINIR_SENHA_ERROR = 'SOLICITAR_REDEFINIR_SENHA_ERROR'
export const FETCH_USUARIOS = 'FETCH_USUARIOS'
export const FETCH_CENTRAIS_CUSTODIA_USUARIO = 'FETCH_CENTRAIS_CUSTODIA_USUARIO'
export const SET_PROCESSANDO_FETCH_USUARIOS = 'SET_PROCESSANDO_FETCH_USUARIOS'

export const setProcessandoUsuarios = (value) => async (dispatch) => {
  dispatch({
    type: SET_PROCESSANDO_FETCH_USUARIOS,
    isProcessandoUsuarios: value,
  })
}

export const fetchUsuarios = (router) => async (dispatch) => {
  dispatch(setProcessandoUsuarios(true))
  try {
    const response = await axios.get(`usuarios`)
    dispatch({
      type: FETCH_USUARIOS,
      usuarios: response.data.usuarios,
    })
  } catch (error) {
    if (error.response.status === 401) {
      dispatch(logoutTokenExpirado(router))
    } else {
      dispatch(criarAlerta(error.response, router, '/usuarios'))
    }
  }
  dispatch(setProcessandoUsuarios(false))
}
